import { DashboardModule } from '@domain-group/suit-theme'

import { DataStoreItemGroup } from '@functions/groupDataStoreItems'

import DataStoreGroupSection from './DataStoreGroupSection'

interface DataStoreGroupProps {
  group: DataStoreItemGroup,
  isSingleGroup: boolean,
}

const DataStoreGroup = (props: DataStoreGroupProps) => {
  const { group: { key, sections }, isSingleGroup } = props

  return (
    // @ts-expect-error TS2322
    <DashboardModule title={key}>
      {/*
       // @ts-expect-error TS2322 */}
      <DashboardModule.ScrollableSection flexDirection="column" maxHeight={isSingleGroup ? 1200 : 600}>
        {Object.values(sections).map((section, index) => (
          <DataStoreGroupSection
            index={index}
            // @ts-expect-error TS2339
            key={section.key}
            // @ts-expect-error TS2322
            section={section}
          />
        ))}
      </DashboardModule.ScrollableSection>
    </DashboardModule>
  )
}

export default DataStoreGroup
